import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import {
  createFeedback,
  failFeedbackSubmit,
  generateFollowUps,
  resetFeedbackSubmitted,
} from '../../redux/feedback/actions'
import {
  feedbackIsSubmitting,
  feedbackIsSubmitted,
  feedbackSubmitError,
} from '../../redux/feedback/selectors'
import FeedbackWidget, { IProps } from './FeedbackWidget'

const selector = createStructuredSelector({
  isSubmitting: feedbackIsSubmitting,
  isSubmitted: feedbackIsSubmitted,
  submitError: feedbackSubmitError,
})

const actions = {
  createFeedback,
  generateFollowUps,
  failFeedbackSubmit,
  resetFeedbackSubmitted,
}

const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, FeedbackWidget)
